import { DESKTOP_NAVBAR_HEIGHT, SIDEBAR_WIDTH, } from 'src/constants/dimensions';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        width: SIDEBAR_WIDTH,
    },
    brandRow: {
        height: DESKTOP_NAVBAR_HEIGHT,
        paddingHorizontal: theme.spacing.standard.md,
    },
    item: {
        minHeight: 40,
        paddingVertical: theme.spacing.standard.xs,
        paddingHorizontal: theme.spacing.standard.md,
        borderLeftWidth: 3,
        borderLeftColor: 'transparent',
    },
    itemFocused: {
        borderLeftColor: theme.palette.primary.main,
        backgroundColor: theme.palette.background.main,
    },
    footer: {
        borderTopWidth: 1,
        borderTopColor: theme.palette.divider.main,
        paddingTop: theme.spacing.standard.sm,
    },
    iconSlot: {
        width: theme.iconSize.sm,
        height: theme.iconSize.sm,
        alignItems: 'center',
        justifyContent: 'center',
    },
    badge: {
        position: 'absolute',
        top: -6,
        right: -8,
        minWidth: 16,
        height: 16,
        borderRadius: 8,
        paddingHorizontal: 4,
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
export default stylesGenerator;
